import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { useCached } from "../lib/dataCache";
import { Card, CardContent } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { Send, Clock } from "lucide-react";
import { toast } from "sonner";

export default function Reminders() {
  const [rentals, setRentals] = useCached("reminders_rentals", []);

  const load = () => api.get("/rentals").then(r => setRentals(r.data.filter(x => x.status !== "returned")));
  useEffect(() => { load(); }, []);

  const send = async (id, kind) => {
    try {
      const r = await api.post(`/whatsapp/remind/${id}/${kind}`);
      if (r.data.mocked) toast.info("Mode simulasi (FONNTE_TOKEN belum diisi). Pesan tidak benar-benar terkirim.");
      else if (r.data.status) toast.success("Terkirim");
      else toast.error(r.data.reason || r.data.error || "Gagal kirim");
      load();
    } catch (err) { toast.error(err.response?.data?.detail || "Gagal"); }
  };

  const today = new Date().toISOString().slice(0,10);
  const tomorrow = new Date(Date.now()+86400000).toISOString().slice(0,10);

  return (
    <div className="space-y-6" data-testid="reminders-page">
      <div>
        <div className="text-xs uppercase tracking-[0.2em] text-neutral-500 font-semibold">WhatsApp</div>
        <h1 className="font-display text-3xl md:text-4xl font-bold text-neutral-900 mt-1">Pengingat Otomatis</h1>
        <p className="text-neutral-600 mt-2 text-sm">Scheduler mengirim otomatis pukul 09:00 WITA setiap hari untuk transaksi H-1. Anda juga dapat mengirim manual di bawah.</p>
      </div>

      <Card className="border-neutral-200 shadow-none">
        <CardContent className="p-6">
          <div className="flex items-center gap-2 mb-3">
            <Clock className="w-4 h-4 text-red-600" />
            <div className="text-xs uppercase tracking-wider font-semibold text-neutral-700">Prioritas Hari Ini & H-1</div>
          </div>
          <div className="space-y-3">
            {rentals.map(r => {
              const pickupTomorrow = r.start_date === tomorrow;
              const returnTomorrow = r.end_date === tomorrow;
              return (
                <div key={r.id} className="border border-neutral-200 rounded p-4 flex flex-wrap items-center justify-between gap-3">
                  <div>
                    <div className="font-medium text-neutral-900">{r.customer_name} <span className="text-xs text-neutral-500 font-mono-tab">· {r.customer_whatsapp}</span></div>
                    <div className="text-xs text-neutral-500 mt-0.5 font-mono-tab">{r.code} · {r.start_date} → {r.end_date}</div>
                    <div className="flex gap-2 mt-2">
                      {pickupTomorrow && <span className="text-[10px] uppercase font-bold px-2 py-1 rounded bg-red-50 text-red-700 border border-red-200">Ambil Besok</span>}
                      {returnTomorrow && <span className="text-[10px] uppercase font-bold px-2 py-1 rounded bg-red-50 text-red-700 border border-red-200">Kembali Besok</span>}
                      {r.reminder_pickup_sent && <span className="text-[10px] uppercase font-bold px-2 py-1 rounded bg-neutral-100 text-neutral-600">Pickup ✓</span>}
                      {r.reminder_return_sent && <span className="text-[10px] uppercase font-bold px-2 py-1 rounded bg-neutral-100 text-neutral-600">Return ✓</span>}
                    </div>
                  </div>
                  <div className="flex gap-2">
                    <Button data-testid={`send-pickup-${r.id}`} size="sm" variant="outline" onClick={() => send(r.id, "pickup")}><Send className="w-3 h-3 mr-1" /> Pengingat Ambil</Button>
                    <Button data-testid={`send-return-${r.id}`} size="sm" variant="outline" onClick={() => send(r.id, "return")}><Send className="w-3 h-3 mr-1" /> Pengingat Kembali</Button>
                  </div>
                </div>
              );
            })}
            {rentals.length === 0 && <div className="text-center py-10 text-neutral-500">Tidak ada reservasi aktif</div>}
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
